import type { FC, AnchorHTMLAttributes } from 'react';

export type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement>;

export const Link: FC<LinkProps> = ({ className = '', children, ...props }) => (
  <a className={`link ${className}`.trim()} {...props}>
    {children}
  </a>
);
